export default class AIValidationError extends Error {

}